<template>
  <model-form
    :title="$t('pricing.tax')"
    :model="tax"
    modal-type="modal"
  >
    <div class="column">
      <div class="row q-col-gutter-sm items-start">
        <q-input
          v-model="tax.name"
          class="col-6"
          label="Name"
          :rules="[val => !!val || 'Field is required']"
          bottom-slots
          :autofocus="!$q.platform.is.ios"
        />
        <q-input
          :model-value="tax.percentThousandths / 1000"
          class="col"
          :label="$t('pricing.tax') + ' Rate'"
          suffix="%"
          type="number"
          step="0.01"
          :rules="[val => val !== null || 'Field is required']"
          bottom-slots
          @update:model-value="value => tax.percentThousandths = value * 1000"
        />
      </div>
    </div>
    <div class="row q-col-gutter-sm items-start">
      <q-select
        v-model="tax.siteIds"
        label="Sites Where Tax Applies"
        outlined
        class="col"
        multiple
        clearable
        :options="$_.unionBy(tax.sites.data, currentCircuit.sites.data, 'id')"
        stack-label
        bottom-slots
        map-options
        emit-value
        option-value="id"
        menu-anchor="bottom left"
      >
        <template #selected-item="scope">
          <q-chip
            removable
            dense
            :tabindex="scope.tabindex"
            :label="scope.opt.name"
            @remove="scope.removeAtIndex(scope.index)"
          />
        </template>
        <template #option="scope">
          <q-item
            v-bind="scope.itemProps"
            v-on="scope.itemEvents"
          >
            <q-item-section>
              {{ scope.opt.name }}
            </q-item-section>
          </q-item>
        </template>
      </q-select>
    </div>
  </model-form>
</template>

<script>

import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'

export default {
  name: 'TaxForm',
  components: {
    ModelForm
  },
  data () {
    return {
    }
  },
  configuration: ['currentCircuit'],
  models: {
    tax: {
      sites: 'default'
    }
  }
}

</script>
